;(()=>{
    function onDomReady() {
        console.log('ScrollObject.js');
        if (window.acf) {
            console.log('[SCROLL-OBJECT-ACF]')
            function onReady() {
                const $scrollObjects = document.querySelectorAll('[scroll-object]');
                $scrollObjects.forEach(el => {
                    if (!el.classList.contains('in-view')) {
                        el.classList.add('in-view');
                        el.hasInitAdmin = true;
                        if (el.hasAttribute('data-scale')) {
                            let scale = Number(el.getAttribute('data-scale'));
                            el.style.setProperty('--scaleX', scale );        
                            el.style.setProperty('--scaleY', scale );
                        }
                    }
                });
            }
            window.acf.addAction(`render_block_preview`, onReady)
        }
        else {
            const $scrollObjects = document.querySelectorAll('[scroll-object]');
            function onIntersect(entries) {
                entries.forEach(el => {
                    if (el.isIntersecting) {
                        el.target.classList.add('in-view');
                    }
                    else {
                        // el.target.classList.remove('in-view');
                    }
                    if (el.target.hasAttribute('data-scale')) {
                        let scale = Number(el.target.getAttribute('data-scale'));
                        if (el.isIntersecting) {
                            el.target.style.setProperty('--scaleX', scale );
                            el.target.style.setProperty('--scaleY', scale );
                        }
                        else {
                            el.target.style.removeProperty('--scaleX');
                            el.target.style.removeProperty('--scaleY');
                        }
                    }
                });
            }
            let observer = new IntersectionObserver( onIntersect );
            $scrollObjects.forEach(el => observer.observe(el) );
        }
    }
    
    if (document.readyState === 'complete') {
        onDomReady();
    }
    else {
        window.addEventListener("DOMContentLoaded", onDomReady );
    }
})();